// extracted by mini-css-extract-plugin
module.exports = {"modal":"LoomDemoModal_modal__3Xr9U","closeIcon":"LoomDemoModal_closeIcon__2GYKF","container":"LoomDemoModal_container__SwgHH","video":"LoomDemoModal_video__N7Oqu"};